import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import theme from './theme';
import Layout from './components/layout/Layout';
import GlobalStyles from './globalStyles';
import './i18n';
import LanguageRouter from './components/common/LanguageRouter';
import TawkTo from './components/common/TawkTo';
import ScrollToTop from './components/common/ScrollToTop';

// Pages
import HomePage from './pages/HomePage';
import AboutPage from './pages/about/AboutPage';
import MissionVisionPage from './pages/about/MissionVisionPage';
import NewsPage from './pages/news/NewsPage';
import NewsDetailPage from './pages/news/NewsDetailPage';
import PrivacyPolicyPage from './pages/privacy/PrivacyPolicyPage';
import CookiesPage from './pages/policies/CookiesPage';
import GDPRPage from './pages/policies/GDPRPage';
import ECommerceSolutionsPage from './pages/solutions/ECommerceSolutionsPage';
import IndustriesSolutionsPage from './pages/industries/IndustriesSolutionsPage';
import PaymentSolutionsPage from './pages/payment/PaymentSolutionsPage';
import FeaturesPage from './pages/features/FeaturesPage';
import ReferencesPage from './pages/references/ReferencesPage';
import SupplyChainPage from './pages/features/SupplyChainPage';
import StockManagementPage from './pages/features/StockManagementPage';
import SalesRepPage from './pages/features/SalesRepPage';
import AnalyticsPage from './pages/features/AnalyticsPage';
import ERPIntegrationPage from './pages/features/ERPIntegrationPage';
import MobileOrderPage from './pages/features/MobileOrderPage';
import BenefitsPage from './pages/benefits/BenefitsPage';
import DealerManagementPage from './pages/dealer/DealerManagementPage';
import FoodIndustryPage from './pages/industries/FoodIndustryPage';
import AutomotiveIndustryPage from './pages/industries/AutomotiveIndustryPage';
import TireIndustryPage from './pages/industries/TireIndustryPage';
import TextileIndustryPage from './pages/industries/TextileIndustryPage';
import ConstructionIndustryPage from './pages/industries/ConstructionIndustryPage';
import HomeIndustryPage from './pages/industries/HomeIndustryPage';
import ElectronicsIndustryPage from './pages/industries/ElectronicsIndustryPage';
import PublishingIndustryPage from './pages/industries/PublishingIndustryPage';
import OpticalIndustryPage from './pages/industries/OpticalIndustryPage';
import IntegrationPage from './pages/integration/IntegrationPage';
import PricingPage from './pages/pricing/PricingPage';
import CustomPricingPage from './pages/pricing/CustomPricingPage';
import ContactPage from './pages/contact/ContactPage';
import DemoPage from './pages/demo/DemoPage';
import FAQPage from './pages/faq/FAQPage';
import B2BB4BPage from './pages/b4b/B2BB4BPage';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <Router>
        <ScrollToTop />
        <Routes>
          {/* Redirect root to English */}
          <Route path="/" element={<Navigate to="/en" replace />} />
          
          {/* Language-based routes */}
          <Route path="/:lang/*" element={
            <LanguageRouter>
        <Layout>
          <Routes>
                  <Route index element={<HomePage />} />
                  <Route path="about" element={<AboutPage />} />
                  <Route path="mission-vision" element={<MissionVisionPage />} />
                  <Route path="news" element={<NewsPage />} />
                  <Route path="news/:slug" element={<NewsDetailPage />} />
                  <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
                  <Route path="cookies" element={<CookiesPage />} />
                  <Route path="gdpr" element={<GDPRPage />} />
                  <Route path="ecommerce" element={<ECommerceSolutionsPage />} />
                  <Route path="industries" element={<IndustriesSolutionsPage />} />
                  <Route path="industries/food" element={<FoodIndustryPage />} />
                  <Route path="industries/automotive" element={<AutomotiveIndustryPage />} />
                  <Route path="industries/tire" element={<TireIndustryPage />} />
                  <Route path="industries/textile" element={<TextileIndustryPage />} />
                  <Route path="industries/construction" element={<ConstructionIndustryPage />} />
                  <Route path="industries/home" element={<HomeIndustryPage />} />
                  <Route path="industries/electronics" element={<ElectronicsIndustryPage />} />
                  <Route path="industries/publishing" element={<PublishingIndustryPage />} />
                  <Route path="industries/optical" element={<OpticalIndustryPage />} />
                  <Route path="payment" element={<PaymentSolutionsPage />} />
                  <Route path="features" element={<FeaturesPage />} />
                  <Route path="features/supply-chain" element={<SupplyChainPage />} />
                  <Route path="features/stock-management" element={<StockManagementPage />} />
                  <Route path="features/sales-rep" element={<SalesRepPage />} />
                  <Route path="features/analytics" element={<AnalyticsPage />} />
                  <Route path="features/erp-integration" element={<ERPIntegrationPage />} />
                  <Route path="features/mobile-order" element={<MobileOrderPage />} />
                  <Route path="benefits" element={<BenefitsPage />} />
                  <Route path="dealer-management" element={<DealerManagementPage />} />
                  <Route path="b2b-b4b" element={<B2BB4BPage />} />
                  <Route path="integration" element={<IntegrationPage />} />
                  <Route path="pricing" element={<PricingPage />} />
                  <Route path="custom-prices" element={<CustomPricingPage />} />
                  <Route path="references" element={<ReferencesPage />} />
                  <Route path="contact" element={<ContactPage />} />
                  <Route path="demo" element={<DemoPage />} />
                  <Route path="faq" element={<FAQPage />} />
            <Route path="*" element={
              <div className="container" style={{ padding: '5rem 0', textAlign: 'center' }}>
                      <h1>Page Not Found</h1>
                      <p>The page you are looking for could not be found.</p>
              </div>
            } />
          </Routes>
                <TawkTo />
        </Layout>
            </LanguageRouter>
          } />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
